import React from "react"
import styles from "./styles.scss"
import { Parallax, Background } from "react-parallax"
import cx from "classnames"

class Image extends React.Component {
  render() {
    const { image, imageStyles, altText } = this.props
    return (
      <div className={styles.container}>
        <Parallax strength={200} className={styles.parallax}>
          <Background className={styles.background}>
            <img
              src={image}
              className={cx(styles.image, imageStyles)}
              alt={altText}
            />
          </Background>
        </Parallax>
      </div>
    )
  }
}

export default Image



// WEBPACK FOOTER //
// ./src/components/CaseStudy/Image/index.jsx